import type { OrderBadge, OrderSummary } from '@repo/api-contracts';
import type { StatusTone } from '@/shared/ui';

/**
 * 주문 상태 배지(StatusBadge) 톤 — 관리자가 지금 무엇을 해야 하는지로 나눈다(develop 톤 체계 안에서 매핑).
 * - attention(라임): 결제를 마친 뒤 배송 완료 전까지 운영자가 처리할 건 — 결제 완료(제작 착수)·제작 중(출고)·배송 중(배송 완료).
 *   사용자 결정(2026-10-13): "admin 배지 색은 일단 라임으로" — 제작 중·배송 중도 결제 완료와 같은 라임이다.
 * - warning: 처리 중 취소 요청(고객 요청·공급 불가) — 환급 기한 안에 환불하거나 반려해야 한다.
 * - neutral: 고객 결제 대기.
 * - positive: 배송 완료.
 * - danger: 더 진행되지 않는 주문 취소·환불 완료.
 * 표시 이름(displayStatus)은 서버가 정하고, 톤은 같은 근거(상태·제작 단계·처리 중 취소 요청)로 고른다.
 */
export const orderStatusTone = (
  order: Pick<OrderSummary, 'status' | 'fulfillmentStatus' | 'pendingCancelRequest'>,
): StatusTone => {
  if (order.status === 'CANCELED' || order.status === 'REFUNDED') return 'danger';
  if (order.status === 'PENDING_PAYMENT') return 'neutral';
  if (order.pendingCancelRequest !== null) return 'warning';
  return order.fulfillmentStatus === 'DELIVERED' ? 'positive' : 'attention';
};

/** 처리 필요 배지 톤 — 실패·반송은 danger, 기한·지연·추적 종료·송장 없는 배송지는 warning, 기록성 안내는 neutral. */
export const ORDER_BADGE_TONES: Readonly<Record<OrderBadge, StatusTone>> = {
  CANCEL_REQUESTED: 'warning',
  DELAYED: 'warning',
  ADDRESS_UPDATED: 'neutral',
  WITHDRAWN_USER: 'neutral',
  TRACKING_EXPIRED: 'warning',
  RETURNED: 'danger',
  TRACKING_REGISTER_FAILED: 'danger',
  DESTINATION_NOT_SHIPPED: 'warning',
};
